// Core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../../Middleware/axiosConfig";

// Utils
import { notifyError } from "Services/Utils/toastNotification";

// API End Points
import { API_END_POINTS } from "Middleware/apiEndpoints";

// API calls
//Login request
export const loginRequest = createAsyncThunk("loginRequest", async (data) => {
  const fcmToken = localStorage.getItem("fcmToken");

  // Define custom headers with fcm_token key
  const customHeaders = {
    fcm_token: fcmToken || "",
  };

  // api hit
  const response = await APIKit(false, customHeaders).post(
    `${API_END_POINTS.loginRequest}`,
    data?.data
  );
  if (response?.data?.message === "User logged in successfully!" && response?.status === 200) {
    data?.callBack(response?.data);
    localStorage.setItem("userDetails", JSON.stringify(response?.data?.data));
  } 
  if (response?.data?.message === "Otp sent successfully!" && response?.status === 200) {
    data?.callBack(response?.data);
  }
  if(response?.status === 400) {
    data.callBack(response?.data);
    notifyError(response?.data?.message);
  }
  return response?.data;
});

//Contact Us request
export const contactUsRequest = createAsyncThunk("contactUsRequest", async (data) => {
  // api hit
  const response = await APIKit(false).post(
    `${API_END_POINTS.contactUsRequest}`,
    data?.data
  );
  
  if (response?.status === 200) {
    data?.callBack(response?.data);
  }
  
  if(response?.status === 400) {
    data.callBack(response?.data);
    notifyError(response?.data?.message);
  }
  
  return response?.data;
});

//Logout request
export const logoutRequest = createAsyncThunk("logoutRequest", async (data) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.logoutRequest}`);
  if (response?.status === 200) {
    data?.callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
  }
  return response?.data;
});

//Forgot password request
export const forgotPasswordRequest = createAsyncThunk(
  "forgotPasswordRequest",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.forgotPasswordRequest}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Trigger email for forgot password request
export const triggerEmailForForgotPasswordRequest = createAsyncThunk(
  "triggerEmailForForgotPasswordRequest",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.triggerEmailForForgotPasswordRequest}${data?.email}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Check link for create password request
export const checkLinkForCreatePasswordRequest = createAsyncThunk(
  "checkLinkForCreatePasswordRequest",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.checkLinkForCreatePasswordRequest}${data?.slug}`
    );
    if (response?.status === 200) {
      const userDetails = JSON.parse(localStorage?.getItem("userDetails"));
      const updatedUserDetails = {
        ...userDetails,
        token: response?.data?.token,
        email: response?.data?.email,
      };
      localStorage?.setItem("userDetails", JSON.stringify(updatedUserDetails));
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Change new password request
export const changeNewPasswordRequest = createAsyncThunk(
  "changeNewPasswordRequest",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.changeNewPasswordRequest}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get notification settings request
export const getNotificationSettingsRequest = createAsyncThunk(
  "getNotificationSettingsRequest",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getNotificationSettingsRequest}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Update notification settings request
export const updateNotificationSettingsRequest = createAsyncThunk(
  "updateNotificationSettingsRequest",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.updateNotificationSettingsRequest}${data?.notificationId}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get user details request
export const getUserDetailsRequest = createAsyncThunk(
  "getUserDetailsRequest",
  async (data) => {
    // api hit
    const userDetails = JSON.parse(localStorage?.getItem("userDetails"));
    const response = await APIKit().get(
      `${API_END_POINTS.getUserDetailsRequest}${userDetails?.user_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    //Login Request
    builder
      .addCase(loginRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(loginRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(loginRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Login Request
    builder
      .addCase(logoutRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(logoutRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(logoutRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Forgot password Request
    builder
      .addCase(forgotPasswordRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(forgotPasswordRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(forgotPasswordRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Trigger email for forgot password request
    builder
      .addCase(triggerEmailForForgotPasswordRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        triggerEmailForForgotPasswordRequest.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        triggerEmailForForgotPasswordRequest.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Check link for create password request
    builder
      .addCase(checkLinkForCreatePasswordRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(checkLinkForCreatePasswordRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(checkLinkForCreatePasswordRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Change new password request
    builder
      .addCase(changeNewPasswordRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(changeNewPasswordRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(changeNewPasswordRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get notification settings request
    builder
      .addCase(getNotificationSettingsRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getNotificationSettingsRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getNotificationSettingsRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Update notification settings request
    builder
      .addCase(updateNotificationSettingsRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(updateNotificationSettingsRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(updateNotificationSettingsRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get user details request
    builder
      .addCase(getUserDetailsRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getUserDetailsRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getUserDetailsRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default adminSlice.reducer;
